import { cn } from '@/lib/utils';

interface FrameworkBadgeProps {
  readonly framework: string;
  readonly className?: string;
}

const FRAMEWORK_STYLES: Record<string, string> = {
  CMS: 'bg-blue-500/15 text-blue-400 border-blue-500/30',
  JointCommission: 'bg-purple-500/15 text-purple-400 border-purple-500/30',
  HIPAA: 'bg-teal/15 text-teal-light border-teal/30',
  OSHA: 'bg-orange-500/15 text-orange-400 border-orange-500/30',
  state: 'bg-green-500/15 text-green-400 border-green-500/30',
  State: 'bg-green-500/15 text-green-400 border-green-500/30',
  DEA: 'bg-red-500/15 text-red-400 border-red-500/30',
  FDA: 'bg-sky-500/15 text-sky-400 border-sky-500/30',
  SOC2: 'bg-violet-500/15 text-violet-400 border-violet-500/30',
};

const DEFAULT_STYLE = 'bg-gray-500/15 text-gray-400 border-gray-500/30';

export function FrameworkBadge({ framework, className }: FrameworkBadgeProps) {
  const style = FRAMEWORK_STYLES[framework] ?? DEFAULT_STYLE;

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium',
        style,
        className,
      )}
    >
      {framework}
    </span>
  );
}
